// NPM Imports
import React, { Component } from "react";
import { Tooltip } from "@revvsales/components";
import { SketchPicker } from "react-color";
import { checkStylesInSelection } from "../../utils/editorUtils";
import { checkSelectionHasEntity } from "../../utils/draftUtils";

// Internals imports
import { DOCUMENTS } from "../../constants";

// Destructuring
const { FONT_COLORS } = DOCUMENTS;

export default class CustomColor extends Component {
  customColorListWrapperRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      colorSelected: "#000000",
    };
  }

  componentWillMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidMount = () => {
    this.setState({
      colorSelected: this._getSelectedColor(),
    });
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.editorState.getSelection().getFocusOffset() !==
        this.props.editorState.getSelection().getFocusOffset() &&
      !this.props.editorState.getSelection().isCollapsed()
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(editorState, "FONTCOLOR");
      if (checkCount > 1) {
        this.setState({
          colorSelected: "#ffffff",
        });
        return;
      }
    }
    if (
      prevProps.editorState.getSelection().getAnchorOffset() !==
        this.props.editorState.getSelection().getAnchorOffset() ||
      (prevProps.editorState.getSelection().getFocusOffset() !==
        prevProps.editorState.getSelection().getAnchorOffset() &&
        this.props.editorState.getSelection().getFocusOffset() ===
          this.props.editorState.getSelection().getAnchorOffset())
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(editorState, "FONTCOLOR");
      if (checkCount > 1) {
        this.setState({
          colorSelected: "#ffffff",
        });
        return;
      }
      const colorSelected = this._getSelectedColor();
      if (this.state.colorSelected !== colorSelected) {
        this.setState({
          colorSelected,
        });
      }
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _getSelectedColor = () => {
    const styles = Array.from(
      this.props.editorState.getCurrentInlineStyle(
        this.props.editorState.getSelection().getAnchorOffset(),
      ),
    );

    let getFontColor = null;
    if (styles && styles.length > 0) {
      getFontColor = styles.find(style => style.includes("FONTCOLOR_"));
    }
    let currentAppliedColor = null;
    if (getFontColor) {
      // eslint-disable-next-line prefer-destructuring
      currentAppliedColor = `#${getFontColor.split("_")[1]}`;
    } else {
      const { editorState, metaData } = this.props;

      if (
        metaData &&
        metaData.FONTCOLOR &&
        editorState.getSelection().getAnchorOffset() === 0
      ) {
        currentAppliedColor = `#${metaData.FONTCOLOR.split("_")[1]}`;
      }
    }
    if (!getFontColor && !currentAppliedColor) {
      if (checkSelectionHasEntity(this.props.editorState, "LINK")) {
        currentAppliedColor = "#3d50e0";
      }
    }
    return currentAppliedColor || "#000000";
  };

  _handleClick = e => {
    if (
      !this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "FONT_COLOR"
    ) {
      this.props.toogleToolbarDropDown(null);
      this.props.handleCustomColorDropDownOpen(
        false,
        this.props.activeToolbarDropDown === "FONT_COLOR",
      );
    }
  };

  _saveMetaData = event => {
    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: {
          meta_data: {
            ...this.props.metaData,
            FONTCOLOR: `FONTCOLOR_${event.hex.substring(1, 7)}`,
          },
        },
      },
    ];

    this.props.saveMetaData(data);
  };

  _onChange = event => {
    this._saveMetaData(event);
    this.props.fontColorUpdate(
      "FONTCOLOR",
      `FONTCOLOR_${event.hex.substring(1, 7)}`,
    );
    this.setState({
      colorSelected: event.hex,
    });
  };

  _toggleCustomColorDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "FONT_COLOR" ? null : "FONT_COLOR",
    );
    this.props.handleCustomColorDropDownOpen(
      true,
      this.props.activeToolbarDropDown === "FONT_COLOR",
    );
  };

  render() {
    return (
      <div
        className="draft-edit-items custom-style-wrapper "
        ref={ele => {
          this.node = ele;
        }}>
        <Tooltip
          placement="top"
          overlay="Text color"
          align={{
            offset: [3, 0],
          }}>
          <button
            className={`text-color-btn toolbar-custom-inline-button toolbar-btn ${
              this.props.activeToolbarDropDown === "FONT_COLOR" ? "active" : ""
            }`}
            type="button"
            onMouseDown={this._toggleCustomColorDropdown}
            data-test="custom-color-text-color-btn">
            <strong>A</strong>
            <div
              className="custom-color-bottom"
              style={{ background: this.state.colorSelected }}
            />
          </button>
        </Tooltip>
        {this.props.activeToolbarDropDown === "FONT_COLOR" ? (
          <div
            className="customcolor-dropdown-wrapper"
            ref={this.props.toolbarCustomColorDropdownRef}>
            <SketchPicker
              color={this.state.colorSelected}
              onChange={this._onChange}
              presetColors={FONT_COLORS}
              width={225}
              disableAlpha
              data-test="color-option-picker"
            />
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/CustomColor.js